const invoiceIndexes = [
    'invoiceContactIdx',
    'invoiceCompanyGLAccountIdx',
    'invoiceLineItemIdx',
    'invoiceLineItemCompanyGLAccountIdx',
] as const;

const poIndexes = [
    'purchaseOrderContactIdx',
    'purchaseOrderLineItemIdx',
    'purchaseOrderLineItemCompanyGLAccountIdx',
] as const;

export const documentIndexes = [...invoiceIndexes, ...poIndexes] as const;

export type DocumentIndex = typeof documentIndexes[number];

// todo: verify jsonpath strings are correct
export const documentIndexToJSONPathMapping: Record<DocumentIndex, string> = {
    invoiceContactIdx: '$.BusinessDocFields.Invoice.InvoiceContacts',
    invoiceCompanyGLAccountIdx: '$.BusinessDocFields.Invoice.InvoiceCompanyGLAccounts',
    invoiceLineItemIdx: '$.BusinessDocFields.Invoice.InvoiceLineItems',
    invoiceLineItemCompanyGLAccountIdx:
        '$.BusinessDocFields.Invoice.InvoiceLineItems[*].InvoiceLineItemCompanyGLAccounts',
    purchaseOrderContactIdx: '$.BusinessDocFields.PurchaseOrder.PurchaseOrderContacts',
    purchaseOrderLineItemIdx: '$.BusinessDocFields.PurchaseOrder.PurchaseOrderLineItems',
    purchaseOrderLineItemCompanyGLAccountIdx:
        '$.BusinessDocFields.PurchaseOrder.PurchaseOrderLineItems[*].PurchaseOrderLineItemCompanyGLAccounts',
};
